<!-- eslint-disable vue/no-deprecated-dollar-listeners-api -->
<template>
    <a
        :href="href"
        :target="formattedTarget"
        @click="sendToRoute"
        v-on="$listeners">
        <slot />
    </a>
</template>

<script>
import { eventIsOpeningANewTabOrWindow } from '@/utils/window.utils.js';

export default {
    name: 'PendoRouterLink',
    props: {
        to: {
            type: [String, Object],
            default: undefined,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        target: {
            type: String,
            default: '_self',
        },
        external: {
            type: Boolean,
            default: false,
        },
        replace: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        href () {
            if (this.to == null || this.disabled) {
                return null;
            }

            if (this.external) {
                return this.to;
            }

            try {
                return this.$router.pendo.toPath(this.to);
            } catch (err) {
                console.error('Unable to resolve route in pendo-router-link', this.to, err.message);

                return '';
            }
        },
        formattedTarget () {
            return this.target === '_blank' ? '_blank' : null;
        },
    },
    methods: {
        sendToRoute ($event) {
            if (!this.href || this.formattedTarget === '_blank' || eventIsOpeningANewTabOrWindow($event)) return;

            // in vue-router 4, <a> tags will cause a full page reload - don't let them
            // do their normal behavior and we'll use $router.push instead
            $event.preventDefault();

            if (this.replace) {
                this.$router.replace(this.href);
            } else {
                this.$router.push(this.href);
            }
        },
    },
};
</script>
